//import Libraries
import React, {Component} from 'react';

//import Components
import ContentCard from './ContentCard/ContentCard';
import PromotionCard from './ContentCard/PromotionCard';

//import Style classes
import './Contents.css'

class Contents extends Component{
    state = {
        open: false,
        openIndex: 0,
    }

    componentDidMount(){
        if(window.location.hash){
            var tempId = window.location.hash;
            tempId = tempId.replace("#", "");
            if(this.state.openIndex !== tempId){
                this.setState({open: true, openIndex: tempId})
            }
        }
    }

    clickHandler = (idx, button, type) => {
        if(this.state.openIndex === idx && this.state.open === true){
            if(button == true){
                this.setState({open: false, openIndex: 0});
            }
        }else{
            this.setState({open: true, openIndex: idx});
        }
    }

    render(){
        const promotion = 
        <div className="PromotionWrapper">  
            {
                this.props.data.items.map((obj, idx)=>{
                    if(obj.promotion === 'on') {
                        return <PromotionCard data={obj}
                                open={true}
                                index={idx}
                                key={idx}
                                lang={this.props.lang} 
                                storagePath={this.props.data.storagePath} />
                    }
                })
            }
        </div>
        const contentCards = 
        <React.Fragment>
        {   this.props.data.items.map((obj, idx)=>{
            // console.log("[Content.js]", obj)
                let openBool = false;
                if(obj.id === this.state.openIndex && this.state.open === true){
                    openBool = true;
                }  
                return(
                    <ContentCard data={obj}
                    lang={this.props.lang}
                    key={idx}
                    index={idx}
                    open={openBool}
                    clickHandler={this.clickHandler}
                    storagePath={this.props.data.storagePath}/>
                )
            })
        }
        </React.Fragment>

        return (
            <div className="Contents">
                {promotion}
                <div className="ContentCardWrapper">
                    {contentCards}
                </div>
            </div>
        )
    }
}

export default Contents;


// WEBPACK FOOTER //
// ./src/components/DepartmentModule/Contents/Contents.js